






// @ is an alias to /src
import HeadlineCarousel from '@/components/HeadlineCarousel.vue'

export default {
    name: 'Home',
    components: {
        HeadlineCarousel,
    },
}
